import useMediaQuery from '@material-ui/core/useMediaQuery';
import React, { useContext, useLayoutEffect, useRef } from 'react';
import AloSidebar from 'src/scripts/templates/_shared/ui-components/YogaUI/alo-ui/AloSidebar';
import { ProductContext } from '../../ProductContext';
import SizeGuideContent from './SizeGuideContent';
import { getGenderAndCategoryData } from './utils';
import { useRestoreFocusOnOpen } from 'src/scripts/templates/_shared/react-hooks';
import ErrorBoundary from 'src/scripts/utils/react/ErrorBoundary';

const SizeGuide = ({ productType, quickFitText }: { productType: string; quickFitText: string | null }) => {
  const { isSizeGuideOpen, toggleSizeGuide } = useContext(ProductContext);
  const isMobile = useMediaQuery('(max-width:768px)');

  const { gender, titlePrefix, category, subcategory } = getGenderAndCategoryData(productType);

  // Lock body scroll. Not using the existing custom hook since we need more control here
  useLayoutEffect(() => {
    if (isSizeGuideOpen && !isMobile) {
      document.body.classList.add('locked');
    }
    return () => {
      if (isSizeGuideOpen && !isMobile) {
        document.body.classList.remove('locked');
      }
    };
  }, [isSizeGuideOpen, isMobile]);

  // now that we have one unisex chart for shoes & socks, we don't want to gender the size chart when viewing a sock or shoe product
  const dontShowGenderTitlePrefix =
    gender &&
    (category?.includes('socks') ||
      subcategory?.includes('socks') ||
      category?.includes('shoes') ||
      subcategory?.includes('shoes'));

  // Restore focus to the sidebar when opened
  const sidebarRef = useRef<HTMLDivElement>(null);
  useRestoreFocusOnOpen(isSizeGuideOpen, sidebarRef);

  return (
    <AloSidebar
      ref={sidebarRef}
      headerBorder={true}
      title={dontShowGenderTitlePrefix ? 'size guide' : `${titlePrefix} size guide`}
      visible={isSizeGuideOpen}
      onClose={() => toggleSizeGuide(false)}
      desktopWidth={730}
      wrapperClass="pdp-size-guide-sidebar"
    >
      <ErrorBoundary className="centered-message">
        <SizeGuideContent gender={gender} category={category} subcategory={subcategory} quickFitText={quickFitText} />
      </ErrorBoundary>
    </AloSidebar>
  );
};

export default SizeGuide;
